import React, { useState } from 'react';
import './VideoBackground.css';

const VideoBackground = () => {
  const [videoError, setVideoError] = useState(false);

  const handleVideoError = (e) => {
    console.error('Video failed to load:', e);
    setVideoError(true);
  };

  const handleVideoLoaded = () => {
    console.log('Video loaded successfully');
  };

  return (
    <div className="video-background-container">
      <video 
        className="video-background"
        autoPlay 
        loop 
        muted 
        playsInline
        preload="auto"
        onError={handleVideoError}
        onLoadedData={handleVideoLoaded}
      >
        <source src={`${process.env.PUBLIC_URL}/images/BG_Video.mp4`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="video-overlay"></div>
      {videoError && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          zIndex: 100
        }}>
          Video failed to load. Check console for details.
        </div>
      )}
    </div>
  );
};

export default VideoBackground;
